function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56.0109 119.973C241.023 57.9581 564.381 -44.2253 685.829 20.9294C807.277 86.0841 559.699 80.4839 711.725 268.096C863.751 455.708 759.521 456.009 679.043 456.009C598.565 456.009 305.941 338.759 184.965 407.879C63.9899 477 -82.1284 166.277 56.0109 119.973Z",
  fill: "#00ADB5",
  fillOpacity: 0.08
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 546.857,
  y: 273.429,
  width: 32.6351,
  height: 81.1466,
  transform: "rotate(-90 546.857 273.429)",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 735.171,
  cy: 168.027,
  r: 33.0761,
  fill: "#00ADB5",
  fillOpacity: 0.08
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M105.773 271.045H204.364V314H228.5V271.045H257.136V248.545H228.5V104.545H197.818L105.773 250.182V271.045ZM204.364 248.545H133.182V246.909L202.727 136.864H204.364V248.545Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M469.773 271.045H568.364V314H592.5V271.045H621.136V248.545H592.5V104.545H561.818L469.773 250.182V271.045ZM568.364 248.545H497.182V246.909L566.727 136.864H568.364V248.545Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M433.383 214.175C433.383 245.613 425.052 264.843 413.405 276.279C401.71 287.763 385.016 293.018 364.942 293.018C344.868 293.018 328.173 287.763 316.478 276.279C304.831 264.843 296.5 245.613 296.5 214.175C296.5 182.741 304.848 160.056 317.157 145.421C329.357 130.915 346.099 123.5 364.942 123.5C383.784 123.5 400.526 130.915 412.726 145.421C425.035 160.056 433.383 182.741 433.383 214.175Z",
  stroke: "white",
  strokeWidth: 21
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 559.206,
  y: 224.035,
  width: 32.6351,
  height: 83.7927,
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M693.789 332.819H683.918L680.419 329.445C692.665 315.2 700.037 296.707 700.037 276.59C700.037 231.731 663.675 195.369 618.817 195.369C573.958 195.369 537.597 231.731 537.597 276.59C537.597 321.448 573.958 357.81 618.817 357.81C638.934 357.81 657.428 350.437 671.672 338.192L675.046 341.691V351.562L737.523 413.914L756.141 395.296L693.789 332.819V332.819ZM618.817 332.819C587.703 332.819 562.587 307.703 562.587 276.59C562.587 245.476 587.703 220.36 618.817 220.36C649.93 220.36 675.046 245.476 675.046 276.59C675.046 307.703 649.93 332.819 618.817 332.819Z",
  fill: "#00ADB5"
});

var Svg404White = function Svg404White(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 458",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404White, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404-white.d8ffffd0.svg";
export { ForwardRef as ReactComponent };